export { default } from '@shikijs/langs/kotlin'
